var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconAcctFaucet = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7458_52369)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.75 1.5C7.75 1.08579 8.08579 0.75 8.5 0.75H14.5C14.9142 0.75 15.25 1.08579 15.25 1.5C15.25 1.91421 14.9142 2.25 14.5 2.25H12.25V3.25H14.5C14.9142 3.25 15.25 3.58579 15.25 4V9C15.25 9.19891 15.171 9.38968 15.0303 9.53033C14.8897 9.67098 14.6989 9.75 14.5 9.75L7.25 9.75V12C7.25 12.4142 6.91421 12.75 6.5 12.75H1.5C1.08579 12.75 0.75 12.4142 0.75 12V6.95931C0.75 4.90792 2.41875 3.25 4.47102 3.25L10.75 3.25V2.25H8.5C8.08579 2.25 7.75 1.91421 7.75 1.5ZM11.4997 4.75L4.47102 4.75C3.24159 4.75 2.25 5.74193 2.25 6.95931V11.25H5.75V9.59186C5.75 8.84798 6.35462 8.25 7.0942 8.25L13.75 8.25V4.75H11.4997ZM0.75 14.5C0.75 14.0858 1.08579 13.75 1.5 13.75H6.5C6.91421 13.75 7.25 14.0858 7.25 14.5C7.25 14.9142 6.91421 15.25 6.5 15.25H1.5C1.08579 15.25 0.75 14.9142 0.75 14.5Z",
    fill: "#00BFBF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7458_52369"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconAcctFaucet);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_acct_faucet.dd22602888bd43eada4c46242e3b2511.svg";